module.exports = __webpack_public_path__ + "static/media/productCloudIcon.070dca28.svg";